import React from 'react';
import LeftSidebar from '@/components/left-sidebar';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuthState } from '../states/auth.state';

const PrivateRoute: React.FC = () => {
  const { isAuthenticated } = useAuthState();

  return isAuthenticated ? (
    <LeftSidebar>
      <Outlet />
    </LeftSidebar>
  ) : (
    <Navigate replace to={'/'} />
  );
};

export default PrivateRoute;
